import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  iaasBlock: 'IAAS-Block',
  vcf: 'VMware Cloud Foundation (VCF)',
  rhoe: 'Red Hat OpenShift Container Platform (RHOCP)',
};

export const severityOptions: FormOptions = {
  high: 'High (widespread impact - business/timelines, etc)',
  medium: 'Medium (service impacted partially; not down)',
  low: 'Low (no impact to business)',
};
